import {
  AccountTree,
  Book as BookIcon,
  Receipt,
} from '@material-ui/icons';

const navAccountingItems = [
  {
    icon: AccountTree,
    href: '/accounting/accounts',
    title: 'accounts',
    module: 'accounting',
  },
  {
    icon: BookIcon,
    href: '/accounting/journal',
    title: 'journal',
    module: 'accounting',
  },
  {
    icon: Receipt,
    href: '/accounting/poliza',
    title: 'poliza',
    module: 'accounting',
  },
  {
    icon: Receipt,
    href: '/accounting/bank_reconciliation',
    title: 'bank_reconciliation',
    module: 'accounting',
  },
];

export default navAccountingItems;
